<template>
  <div id="app" class="wrapper">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'App',
  data: function () {
    return {
      form: new Form({})
    }
  },
  sockets: {
    readMsg: function (message) {
      this.$store.commit('GET_MESSAGE', ({ text: message.text, user: message.user, date: message.date }))
    },
    initChat: function (messages) {
      this.$store.commit('INIT_MESSAGES', messages)
    },
    updateUsers: function (users) {
      this.$store.commit('INIT_USERS', users)
    }
  },
  created: function () {
    if (localStorage.nickname) {
      this.$store.commit('SET_NAME', localStorage.nickname)
    }
    this.checkLogin()
  },
  methods: {
    checkLogin: function () {
      var self = this
      if (localStorage.getItem('token_header') && localStorage.getItem('token_log')) {
        let data = {
          token_header: localStorage.getItem('token_header'),
          token_log: localStorage.getItem('token_log'),
          user_id: localStorage.getItem('user_id')
        }
        this.form.post(baseUrl + 'Home/LoginWithToken', data).then(function (result) {
          if (Number(result.status) === 1) {
            localStorage.setItem('role', result.role)
            self.$store.commit('SET_ROLE', Number(result.role))
            self.$store.commit('SET_NAME', result.nickname)
            localStorage.setItem('nickname', result.nickname)
          } else {
            self.$store.commit('REMOVE_TOKEN')
            if (window.localStorage) {
              window.localStorage.removeItem('token_log')
              window.localStorage.removeItem('token_header')
              window.localStorage.removeItem('role')
              window.localStorage.removeItem('user_id')
              window.localStorage.removeItem('nickname')
            }
            self.$router.push('/login')
          }
        }, function (reason) {
            // rejection
          console.log('Rejected', reason)
        })
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// App.vue?7d0f91d6